import { useEffect } from "react"
import { computeGroupByCorrection } from "connected-components/asset-view/helpers"

// Keeps the asset view's selected grouping valid as isActive/availableGroupByOptions change.
// Extracted from AssetView into its own hook so the effect can be tested (see __tests__) without
// rendering the full connected component.
export function useGroupByIntradayCorrection({ groupBy, isActive, hasMultipleUniqueInstruments, availableGroupByOptions, setGroupBy }) {
  useEffect(() => {
    const { nextGroupBy } = computeGroupByCorrection({ groupBy, isActive, hasMultipleUniqueInstruments, availableGroupByOptions })

    if (nextGroupBy !== undefined) {
      setGroupBy(nextGroupBy)
    }
  }, [groupBy, isActive, hasMultipleUniqueInstruments, availableGroupByOptions, setGroupBy])
}
